<template>
    <cmp-form-field-select
            @input="updateVal($event)"
            v-bind="fieldData"
            v-model="field.val">
    </cmp-form-field-select>
</template>

<script>
    import { mapGetters } from 'vuex';
    import filterMasterMixin from './filter-master-mixin';


    const HIDE_AND_FILL_WHEN_ONE_OPTION = 'hide_and_fill_when_one_option';


    export default {
        mixins: [
            filterMasterMixin,
        ],
        props: {
            field: {
                type: Object,
                required: true,
            },
            filteredBy: {
                type: Array,
                default() {
                    return [];
                },
            },
            filterBehaviour: String,
        },
        computed: {
            ...mapGetters(['form']),
            fieldData() {
                const { placeholder, type, label, id, messages, state } = this.field;

                return Object.assign(
                    { placeholder, type, label, id, messages },
                    { items: this.filteredItems },
                    { state: (this.filteredBy ? this.computedState : state) }
                );
            },
            filterValues() {
                return this.filteredBy
                    .map(filterId => [filterId, this.form.filter[filterId]])
                    .reduce((accumulator, [key, val]) => {
                        accumulator[key] = val;
                        return accumulator;
                    }, {});
            },
            filteredItems() {
                return this.field.items.filter(this.validateItem);
            },
            chosenItem() {
                return this.field.items.find(item => item.val === this.field.val);
            },
            computedState() {
                return Object.assign({}, this.field.state, {
                    disabled: !this.filteredItems.length,
                    hidden: this.filterBehaviourIsHidden,
                });
            },
            filterBehaviourIsHidden() {
                return this.filterBehaviour === HIDE_AND_FILL_WHEN_ONE_OPTION && (this.hasOneItem || !this.filteredItems.length);
            },
            hasOneItem() {
                return this.filteredItems.length === 1;
            },
        },
        methods: {
            validateItem(item) {
                return Object.entries(this.filterValues).every(([key, val]) => {
                    return (val == null) || item.filter[key].includes(val);
                });
            },
        },
        watch: {
            filterValues: {
                handler() {
                    if (this.field.val && !this.validateItem(this.chosenItem)) {
                        this.field.val = '';
                    }

                    if (this.filterBehaviour === HIDE_AND_FILL_WHEN_ONE_OPTION && this.hasOneItem) {
                        this.field.val = this.filteredItems[0].val;
                    }
                },
                deep: true,
                immediate: true,
            },
            filterBehaviourIsHidden: {
                handler(newVal) {
                    if (!newVal) {
                        this.field.val = '';
                    }
                },
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?68194368